var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(function () {
    angular.module('QMC.Reporting', []).config(routes);
    ;
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('report', {
            url: '/report/:id',
            templateUrl: qmcBase + '/Reporting',
            controller: 'ReportingController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: report');
                    }]
            }
        });
        $stateProvider
            .state('reportpreview', {
            url: '/reportpreview/',
            templateUrl: qmcBase + '/Reporting/ReportPreview',
            controller: 'ReportPreviewListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: reportpreview');
                    }]
            }
        });
        $stateProvider
            .state('reportpreviewdetail', {
            url: '/reportpreview/:id',
            templateUrl: qmcBase + '/Reporting/ReportPreview',
            controller: 'ReportPreviewListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: reportpreviewdetail');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        Reporting.HttpProvider = HttpProvider;
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Reporting')
        .config(['$httpProvider', QMC.Reporting.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        var ReportingService = /** @class */ (function (_super) {
            __extends(ReportingService, _super);
            function ReportingService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Reporting';
                return _this;
            }
            ReportingService.prototype.getReportTemplateList = function (objectType) {
                return _super.prototype.get.call(this, this.modulePath + '/Template/' + objectType, {}, function (data) {
                    return data;
                });
            };
            ReportingService.prototype.getUnfetchedReportList = function () {
                return _super.prototype.get.call(this, this.modulePath + '/Job/UnfetchedReportJobList', {}, function (data) {
                    return data;
                });
            };
            ReportingService.prototype.getFinishedReportList = function (unfetchedOnly, daysInPast, page, pageSize, listSearch, searchProperties) {
                if (unfetchedOnly === void 0) { unfetchedOnly = false; }
                if (daysInPast === void 0) { daysInPast = 365; }
                if (page === void 0) { page = -1; }
                if (pageSize === void 0) { pageSize = -1; }
                if (listSearch === void 0) { listSearch = null; }
                if (searchProperties === void 0) { searchProperties = []; }
                return _super.prototype.getItem.call(this, this.modulePath + '/Job/FinishedReportJobs', { unfetchedOnly: unfetchedOnly, daysInPast: daysInPast, page: page, pageSize: pageSize, listSearch: listSearch, searchProperties: searchProperties }, function (data) {
                    return data;
                });
            };
            ReportingService.prototype.getReportParameterList = function (id, reportType) {
                return _super.prototype.get.call(this, this.modulePath + '/Parameter/' + id + '/' + reportType, {}, function (data) {
                    return data;
                });
            };
            ReportingService.prototype.getReportParameterValueList = function (fieldType, valueRange) {
                return _super.prototype.get.call(this, this.modulePath + '/Parameter/Value/' + fieldType + '/' + valueRange, {}, function (data) {
                    return data;
                });
            };
            ReportingService.prototype.getNewReportJobGuid = function () {
                return _super.prototype.get.call(this, this.modulePath + '/Job/NewGuid', {}, function (data) {
                    return data;
                });
            };
            ReportingService.prototype.getFinishedReportBase64 = function (reportJobObjectId, reportTypeValue, reportName) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Job/DownloadResult/' + reportJobObjectId + '/' + reportTypeValue + '/' + reportName, {}, function (data) {
                    return data;
                });
            };
            ReportingService.prototype.getFinishedReportFile = function (data) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Job/DownloadFinishedReport/', { finishedReportJobItemId: data.objectId, serverJobType: data.serverJobType, reportName: data.reportName }, function (data) {
                    return data;
                });
            };
            ReportingService.prototype.getFinishedSpreadServerJobAsPdf = function (objectId, reportName) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Job/DownloadFinishedSpreadReportAsPdf/', { finishedServerJobItemId: objectId, spreadServerJobName: reportName }, function (data) {
                    return data;
                });
            };
            ReportingService.prototype.postReportJob = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Job', data).then(function (data) {
                    return data;
                });
            };
            ReportingService.prototype.markReportFetched = function (payload) {
                return _super.prototype.put.call(this, this.modulePath + '/Job/MarkFetched/' + payload, {}).then(function (data) {
                    return data;
                });
            };
            ReportingService.prototype.cancelRunningReportJob = function (id) {
                _super.prototype.delete.call(this, this.modulePath + '/Job/' + id);
            };
            ReportingService.prototype.deleteSelectedReport = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Job/DeleteFinishedReport/', data).then(function (data) {
                    return data;
                });
            };
            ReportingService.prototype.deleteSelectedReports = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Job/DeleteMultipleFinishedReports/', data).then(function (data) {
                    return data;
                });
            };
            ReportingService.prototype.getDetailReportReferencesByObjectType = function (objectType) {
                return _super.prototype.get.call(this, this.modulePath + '/Parameter/DetailReference/' + objectType, {}, function (data) {
                    return data;
                });
            };
            ReportingService = __decorate([
                QMC.Service('QMC.Reporting', 'ReportingService'),
                QMC.Inject('$http', '$q')
            ], ReportingService);
            return ReportingService;
        }(QMC.Common.BaseService));
        Reporting.ReportingService = ReportingService;
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        var ReportingController = /** @class */ (function () {
            function ReportingController(reportingService, $qui, $state, $scope, $rootScope, mediaService) {
                this.reportingService = reportingService;
                this.$qui = $qui;
                this.$state = $state;
                this.$scope = $scope;
                this.$rootScope = $rootScope;
                this.mediaService = mediaService;
                this.parameterValueFilterText = "";
                this.isLoadingParams = false;
                this.isParamsLoadingError = false;
                this.loadingParamValues = false;
                this.onlyActive = true;
                this.showIsCurrent = false;
                this.detailParams = [];
                this.selectedDetailId = QMC.Common.Constants.GUID_EMPTY;
                this.explanationFile = {
                    isLoading: false
                };
                this.scrollTarget = '';
                this.templateList = [];
                this.events();
                this.getReportingTemplates();
                $qui.init($qui.getSectionColor(this.getPrevState()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
            }
            ReportingController.prototype.getPrevState = function () {
                if (this.$rootScope.currentState === (null || undefined) || this.$rootScope.currentState.name === (null || undefined))
                    return "/";
                console.log(this.$rootScope.currentState.name);
                switch (this.$rootScope.currentState.name) {
                    case 'medicament': return "/medicament";
                    case 'journal': return "/journal";
                    case 'medicamentDistribution': return "/medicament/plannedDistribution";
                    case 'stammdaten.page': return "/stammdaten";
                    case 'stammdaten': return "/stammdaten";
                    default: return "/";
                }
            };
            ReportingController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.selectedTemplateId', function (value) {
                    if (value !== undefined) {
                        _this.getAvailableParameters(value);
                    }
                });
                this.$scope.$watch('vm.paramDateFilter.dateFrom', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (_this.paramDateFilter.dateFrom && _this.paramDateFilter.dateTo && _this.paramDateFilter.dateFrom > _this.paramDateFilter.dateTo) {
                            _this.paramDateFilter.dateFrom = _this.paramDateFilter.dateTo;
                        }
                    }
                });
                this.$scope.$watch('vm.paramDateFilter.dateTo', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (_this.paramDateFilter.dateFrom && _this.paramDateFilter.dateTo && _this.paramDateFilter.dateFrom > _this.paramDateFilter.dateTo) {
                            _this.paramDateFilter.dateFrom = _this.paramDateFilter.dateTo;
                        }
                    }
                });
                this.$scope.$watch('vm.selectAll', function (newValue, oldValue) {
                    if (oldValue !== newValue) {
                        _this.toggleAllCheckboxes();
                    }
                });
            };
            ReportingController.prototype.getNewGuid = function () {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            };
            ReportingController.prototype.getReportingTemplates = function () {
                var _this = this;
                this.reportingService.getReportTemplateList(this.$state.params.id).then(function (data) {
                    _this.templateList = data;
                    _this.templateMap = _this.templateList.map(function (x) { return ({ value: x.objectId, text: x.name, group: x.categoryName, icon: _this.getIcon(x) }); });
                    if (data.length > 0)
                        _this.getAvailableParameters(data[0].objectId);
                });
            };
            ReportingController.prototype.getIcon = function (item) {
                switch (item.reportTypeValue) {
                    case 7000:
                        return 'qm-icon-document_text';
                    case 3000:
                        return 'qm-icon-document_page_number';
                }
                return 'qm-icon-document_information';
            };
            ReportingController.prototype.getDetailParams = function (objectType) {
                var _this = this;
                this.loadingDetailParams = true;
                this.reportingService.getDetailReportReferencesByObjectType(objectType).then(function (data) {
                    _this.detailParams = data.map(function (x) { return ({ value: x.objectId, text: x.name }); });
                    _this.loadingDetailParams = false;
                });
            };
            ReportingController.prototype.getAvailableParameters = function (id) {
                var _this = this;
                var _a;
                this.base64Data = ''; //clean last reports data to hide viewer
                this.isLoadingParams = true;
                this.isParamsLoadingError = false;
                this.selectedTemplateId = id;
                var reportType = this.getReportType();
                if (((_a = this.templateList.filter(function (x) { return x.objectId === id; })[0]) === null || _a === void 0 ? void 0 : _a.isDetail) && (!this.detailParams || this.detailParams.length === 0)) {
                    this.getDetailParams(this.$state.params.id);
                }
                this.reportingService.getReportParameterList(id, reportType).then(function (data) {
                    _this.isLoadingParams = false;
                    _this.availableParameters = data;
                    // Init values
                    for (var i = 0; i < _this.availableParameters.length; i++) {
                        // Init boolean values (default: false, if user set default value: take this)
                        if (_this.availableParameters[i].fieldTypeName === 'Boolean' && _this.availableParameters[i].chosenValues.length >= 1) {
                            _this.availableParameters[i].chosenValues = [{ value: _this.availableParameters[i].chosenValues[0].value.toLowerCase() === "true" }];
                        }
                        if (_this.availableParameters[i].fieldTypeName === 'Boolean' && _this.availableParameters[i].chosenValues.length === 0) {
                            _this.availableParameters[i].chosenValues = [{ value: false }];
                        }
                        // Init text fields, if no default value
                        if (_this.availableParameters[i].fieldTypeName === 'TextField' && (_this.availableParameters[i].chosenValues === null || undefined)) {
                            _this.availableParameters[i].chosenValues = [{ value: "" }];
                        }
                        // Format default date values
                        if (_this.availableParameters[i].setValuesAsDefault && _this.availableParameters[i].fieldTypeName === 'Date') {
                            if (moment(_this.availableParameters[i].chosenValues[0].value, "YYYY-DD-MM").isValid()) {
                                _this.availableParameters[i].chosenValues[0].value = moment(_this.availableParameters[i].chosenValues[0].value, "YYYY-DD-MM").format("YYYY-MM-DD");
                            }
                            if (moment(_this.availableParameters[i].chosenValues[0].value, "DD.MM.YYYY").isValid()) {
                                _this.availableParameters[i].chosenValues[0].value = moment(_this.availableParameters[i].chosenValues[0].value, "DD.MM.YYYY").format("YYYY-MM-DD");
                            }
                            _this.availableParameters[i].chosenValues[0].dateValue = new Date(_this.availableParameters[i].chosenValues[0].value);
                        }
                    }
                }).catch(function () {
                    _this.isLoadingParams = false;
                    _this.isParamsLoadingError = true;
                });
            };
            ReportingController.prototype.getAvailableParameterValues = function (parameter) {
                var _this = this;
                this.additionalProperties = [];
                if (parameter.valueRange !== undefined && parameter.valueRange !== null && parameter.valueRange !== "") {
                    this.resetModal();
                    this.loadingParamValues = true;
                    this.showIsCurrent = false;
                    this.paramDateFilter = {
                        dateFrom: undefined,
                        dateTo: undefined,
                        enable: false
                    };
                    parameter.availableValues = [];
                    this.reportingService.getReportParameterValueList(parameter.fieldType, parameter.valueRange).then(function (data) {
                        parameter.availableValues = data.items;
                        _this.additionalProperties = data.additionalProperties;
                        // Set default values of available values as checked
                        for (var i = 0; i < parameter.availableValues.length; i++) {
                            for (var j = 0; j < parameter.chosenValues.length; j++) {
                                if (parameter.availableValues[i].id === parameter.chosenValues[j].id) {
                                    parameter.availableValues[i].isChecked = true;
                                }
                            }
                            if (!parameter.availableValues[i] !== (null || undefined) && !parameter.availableValues[i].isCurrent)
                                _this.showIsCurrent = true;
                            if (parameter.availableValues[i].dateFrom || parameter.availableValues[i].dateTo)
                                _this.paramDateFilter.enable = true;
                        }
                        parameter.availableValuesMap = _this.$qui.selectAutoMap(data.items, 'objectId', 'name');
                        var dateFromParam = _this.availableParameters.filter(function (x) { return x.name.toLowerCase() === 'datum von'; })[0];
                        var dateToParam = _this.availableParameters.filter(function (x) { return x.name.toLowerCase() === 'datum bis'; })[0];
                        if (dateFromParam && dateFromParam.fieldType === 10 && dateFromParam.chosenValues.length > 0)
                            _this.paramDateFilter.dateFrom = dateFromParam.chosenValues[0].dateValue;
                        if (dateToParam && dateToParam.fieldType === 10 && dateToParam.chosenValues.length > 0)
                            _this.paramDateFilter.dateTo = dateToParam.chosenValues[0].dateValue;
                        _this.currentParameter = parameter;
                        _this.loadingParamValues = false;
                    });
                }
            };
            ReportingController.prototype.valueInDateRange = function (param) {
                if (!this.paramDateFilter.enable)
                    return true;
                // map dates to min/max date if unset to make actual filtering easier
                var filterStartDate = this.paramDateFilter.dateFrom ? new Date(this.paramDateFilter.dateFrom.toString()) : new Date(-8640000000000000);
                var filterEndDate = this.paramDateFilter.dateTo ? new Date(this.paramDateFilter.dateTo.toString()) : new Date(+8640000000000000);
                var paramStartDate = param.dateFrom ? new Date(param.dateFrom.toString()) : new Date(-8640000000000000);
                var paramEndDate = param.dateTo ? new Date(param.dateTo.toString()) : new Date(+8640000000000000);
                if (filterStartDate <= paramStartDate && paramStartDate <= filterEndDate)
                    return true; // param starts in filter
                if (filterStartDate <= paramEndDate && paramEndDate <= filterEndDate)
                    return true; // param ends in filter
                if (paramStartDate <= filterStartDate && filterEndDate <= paramEndDate)
                    return true; // filter in param
                return false;
            };
            ReportingController.prototype.resetModal = function () {
                this.parameterValueFilterText = "";
                this.selectAll = false;
                this.onlyActive = true;
            };
            ReportingController.prototype.addMultiSelectedValues = function () {
                var selectedValues = [];
                for (var i = 0; i < this.currentParameter.availableValues.length; i++) {
                    if (this.currentParameter.availableValues[i].isChecked && (!this.onlyActive || this.currentParameter.availableValues[i].isCurrent)) {
                        selectedValues.push({
                            id: this.currentParameter.availableValues[i].id,
                            objectId: this.currentParameter.availableValues[i].objectId,
                            value: this.currentParameter.availableValues[i].objectId,
                            caption: this.currentParameter.availableValues[i].name !== null && this.currentParameter.availableValues[i].name !== undefined ? this.currentParameter.availableValues[i].name : "",
                            dateValue: null
                        });
                    }
                }
                this.currentParameter.chosenValues = selectedValues;
                this.currentParameter.selectionString = "";
                // Generate selection string:
                for (var i = 0; i < this.currentParameter.chosenValues.length; i++) {
                    this.currentParameter.selectionString += this.currentParameter.chosenValues[i].caption + "; ";
                }
            };
            ReportingController.prototype.getReportType = function () {
                for (var i = 0; i < this.templateList.length; i++) {
                    if (this.templateList[i].objectId === this.selectedTemplateId) {
                        return this.templateList[i].reportTypeValue;
                    }
                }
                return 0;
            };
            ReportingController.prototype.generateReport = function () {
                var _this = this;
                this.generateReportId = this.getNewGuid();
                // Fill date values from dateValue property into value property
                for (var i = 0; i < this.availableParameters.length; i++) {
                    if (this.availableParameters[i].fieldTypeName === 'Date' && this.availableParameters[i].chosenValues.length > 0) {
                        this.availableParameters[i].chosenValues[0].value = this.availableParameters[i].chosenValues[0].dateValue;
                    }
                }
                var params = angular.copy(this.availableParameters);
                var postItem = {
                    reportObjectId: this.selectedTemplateId,
                    serverJobObjectId: this.generateReportId,
                    reportType: this.getReportType(),
                    parameters: params,
                    isCancelled: false,
                    detailParentId: this.isDetail() ? this.selectedDetailId : null
                };
                var _loop_1 = function (param) {
                    if (param.availableValues) {
                        param.chosenValues.forEach(function (val) {
                            var avVal = param.availableValues.filter(function (x) { return x.objectId === val.value; });
                            if (avVal && avVal.length > 0)
                                val.caption = avVal[0].name;
                        });
                        delete param.availableValues;
                        delete param.availableValuesMap;
                    }
                    if (param.description)
                        delete param.description;
                };
                //remove potentially large and not needed availableParameters prop
                for (var _i = 0, _a = postItem.parameters; _i < _a.length; _i++) {
                    var param = _a[_i];
                    _loop_1(param);
                }
                this.reportingService.postReportJob(postItem).then(function (id) {
                    _this.handleFinishedReport(id);
                }).catch(function (id) {
                    _this.handleFinishedReport(id);
                });
            };
            ReportingController.prototype.handleFinishedReport = function (id) {
                if (typeof id !== "string" || !id.match("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$")) {
                    //if (typeof id != "string") {
                    $('#loadingScreen').modal('hide');
                    $('#downloadError').modal('show');
                    return;
                }
                if (this.generateReportId !== null && this.generateReportId !== undefined) {
                    this.getFinishedReportFile(id);
                    this.generateReportId = null;
                }
            };
            ReportingController.prototype.getFinishedReportFile = function (id) {
                var _this = this;
                this.reportFileId = id;
                this.fileName = this.getSelectedReportName();
                this.reportingService.getFinishedReportBase64(id, this.getReportType(), this.fileName).then(function (data) {
                    $('#loadingScreen').modal('hide');
                    _this.fileType = data.filename.substring(data.filename.lastIndexOf('.') + 1);
                    _this.base64Data = data.base64;
                    _this.fileName = data.filename;
                    $('#loadingScreenModal').modal('hide');
                    $('html,body').animate({
                        scrollTop: $("#docBox").offset().top
                    }, 1000);
                });
            };
            ReportingController.prototype.scrollToViewer = function () {
                var _this = this;
                this.$qui.scopeApply(this.$scope);
                setTimeout(function () {
                    if (_this.scrollTarget === 'pdf')
                        $('html,body').animate({
                            scrollTop: $("#docBox").offset().top
                        }, 1000);
                    if (_this.scrollTarget === 'spread')
                        $('html,body').animate({
                            scrollTop: $("#spreadBox").offset().top - 25
                        }, 1000);
                }, 500);
            };
            ReportingController.prototype.cancelReportJob = function () {
                this.reportingService.cancelRunningReportJob(this.generateReportId);
                this.generateReportId = null;
            };
            ReportingController.prototype.runInBackground = function () {
                this.generateReportId = null;
            };
            ReportingController.prototype.getDescription = function () {
                for (var i = 0; i < this.templateList.length; i++) {
                    if (this.selectedTemplateId === this.templateList[i].id)
                        return this.templateList[i].description;
                }
                return '';
            };
            ReportingController.prototype.isDetail = function () {
                for (var i = 0; i < this.templateList.length; i++) {
                    if (this.selectedTemplateId === this.templateList[i].id)
                        return this.templateList[i].isDetail;
                }
                return false;
            };
            ReportingController.prototype.getExplanationFileId = function () {
                var _this = this;
                var _a;
                var explanationId = (_a = this.templateList.filter(function (x) { return x.id === _this.selectedTemplateId; })[0]) === null || _a === void 0 ? void 0 : _a.explanationFileId;
                return explanationId !== null && explanationId !== void 0 ? explanationId : QMC.Common.Constants.GUID_EMPTY;
            };
            ReportingController.prototype.hasExplanationFile = function () {
                return this.getExplanationFileId() !== QMC.Common.Constants.GUID_EMPTY;
            };
            ReportingController.prototype.openExplanationFile = function () {
                var _this = this;
                var id = this.getExplanationFileId();
                if (id === QMC.Common.Constants.GUID_EMPTY) {
                    console.error("No explanationId for template: " + this.selectedTemplateId);
                    return;
                }
                this.explanationFile.isLoading = true;
                $('#previewModal').modal('show');
                this.mediaService.getMediaFile(id)
                    .then(function (data) {
                    _this.explanationFile.data = data;
                    var temp = data.filename.split('.');
                    _this.explanationFile.suffix = temp[temp.length - 1];
                })
                    .catch(function (e) { })
                    .finally(function () { return _this.explanationFile.isLoading = false; });
            };
            ReportingController.prototype.getSelectedReportName = function () {
                for (var i = 0; i < this.templateList.length; i++) {
                    if (this.templateList[i].objectId === this.selectedTemplateId)
                        return this.replaceUmlauts(this.templateList[i].name);
                }
                return "report";
            };
            ReportingController.prototype.toggleAllCheckboxes = function () {
                var toggleState = this.selectAll;
                if (!this.$scope.filteredBoxes)
                    return;
                for (var i = 0; i < this.$scope.filteredBoxes.length; i++) {
                    this.$scope.filteredBoxes[i].isChecked = toggleState;
                }
                this.$qui.scopeApply(this.$scope);
            };
            ReportingController.prototype.getParamTableHeight = function () {
                return document.body.clientHeight - 320;
            };
            /* replaces any umlauts whether upper or lower case with its corresponing ANSII compatible characters  */
            ReportingController.prototype.replaceUmlauts = function (fileName) {
                var umlautMap = {
                    '\u00dc': 'UE',
                    '\u00c4': 'AE',
                    '\u00d6': 'OE',
                    '\u00fc': 'ue',
                    '\u00e4': 'ae',
                    '\u00f6': 'oe',
                    '\u00df': 'ss',
                };
                var result = fileName.replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, function (a) {
                    var big = umlautMap[a.slice(0, 1)];
                    return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
                }).replace(new RegExp('[' + Object.keys(umlautMap).join('|') + ']', "g"), function (a) { return umlautMap[a]; });
                return this.removeInvalidChars(result);
            };
            ReportingController.prototype.removeInvalidChars = function (fileName) {
                var fileNameNoWhiteSpace = fileName.replace(/[\s]/g, "_");
                return fileNameNoWhiteSpace.replace(/[\/\?\#\[\]\@\!\$\&\§\'\(\)\*\+\,\;\:\=]/g, "-"); //vgl: https://stackoverflow.com/questions/2366260/whats-valid-and-whats-not-in-a-uri-query
            };
            ReportingController = __decorate([
                QMC.Controller('QMC.Reporting', 'ReportingController'),
                QMC.Inject('ReportingService', '$qui', '$state', '$scope', '$rootScope', 'QmcMediaService')
            ], ReportingController);
            return ReportingController;
        }());
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        var ReportPreviewListController = /** @class */ (function () {
            /*constructor*/
            function ReportPreviewListController($qui, lngService, reportingService, userService, $location, $scope, $state, $stateParams) {
                var _this = this;
                this.$qui = $qui;
                this.lngService = lngService;
                this.reportingService = reportingService;
                this.userService = userService;
                this.$location = $location;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                /*Interface*/
                this.ui = new Reporting.UserInterfaceReportPreview();
                this.tableFilter = "";
                /*variables*/
                this.finishedReportList = [];
                this.selectedForRemovalList = [];
                this.shouldLoadTableData = true;
                this.debounceChkBx = false;
                this.page = 0;
                this.formState = 'new';
                this.loading = {
                    list: false,
                    unfetched: false,
                    daysInPast: 7,
                    firstLoad: true,
                    page: 0,
                    tableFilter: ''
                };
                this.errorInfoModalMessage = {
                    serverMessage: '',
                    errorTrace: ''
                };
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.init();
                if ($stateParams.id !== undefined) {
                    this.externallySelectedReportId = $stateParams.id;
                }
                this.$qui.getTableAutoload(this.userService).then(function (ltd) {
                    _this.shouldLoadTableData = ltd;
                    _this.userService.getUserSettings(["DLGREPORTINGSERVERJOBS.DAYSINPAST", "DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED"], false).then(function (data2) {
                        _this.daysInPast = parseInt(data2[0].value);
                        _this.showOnlyUnfetchedData = (data2[1].value.toLowerCase() === "true");
                        _this.loading.daysInPast = _this.daysInPast;
                        _this.loading.unfetched = _this.showOnlyUnfetchedData;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                            _this.$scope.$watch('vm.tableFilter', function (newValue, oldValue) {
                                if (newValue === oldValue)
                                    return;
                                var current = _this.tableFilter;
                                setTimeout(function () {
                                    if (current === _this.tableFilter) {
                                        _this.page = 0;
                                        _this.getData();
                                    }
                                    _this.$qui.scopeApply(_this.$scope);
                                }, 500);
                            });
                            _this.$scope.$watch('vm.daysInPast', function (newValue, oldValue) {
                                if (newValue === oldValue)
                                    return;
                                var current = _this.daysInPast;
                                setTimeout(function () {
                                    if (current === _this.daysInPast) {
                                        _this.page = 0;
                                        _this.getData();
                                    }
                                    _this.$qui.scopeApply(_this.$scope);
                                }, 500);
                            });
                            _this.$scope.$watch('vm.showOnlyUnfetchedData', function (newValue, oldValue) {
                                if (newValue !== oldValue && !_this.debounceChkBx) {
                                    _this.debounceChkBx = true;
                                    setTimeout(function () {
                                        _this.page = 0;
                                        _this.getData();
                                        _this.debounceChkBx = false;
                                    }, 250);
                                }
                            });
                        }
                    });
                });
            }
            /*local init*/
            ReportPreviewListController.prototype.init = function () {
                var _this = this;
                this.$scope.$watch('vm.page', function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        _this.getData();
                });
                this.promptOptions = {
                    title: this.lngService.translate(20002016, "Hinweis"),
                    yesNo: true,
                    icon: "qm-icon-trash",
                    text: this.lngService.translate(20015049, "Wollen Sie die Auswertung wirklich löschen?")
                };
                this.promptOptionsMulti = {
                    title: this.lngService.translate(20002016, "Hinweis"),
                    yesNo: true,
                    icon: "qm-icon-trash",
                    text: this.lngService.translate(20015056, "Wollen Sie die ausgewählten Auswertungen wirklich löschen?")
                };
            };
            /*acquire finished reports from server*/
            ReportPreviewListController.prototype.getData = function () {
                var _this = this;
                if ((this.loading.daysInPast === this.daysInPast) && (this.loading.unfetched === this.showOnlyUnfetchedData) && (this.loading.page === this.page)
                    && (this.tableFilter === undefined) && !this.loading.firstLoad)
                    return;
                this.loading.firstLoad = false;
                this.loading.list = true;
                this.reportingService.getFinishedReportList(this.showOnlyUnfetchedData, this.daysInPast, this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, this.tableFilter, this.ui.getDisplayedPropertiesFromSchema(this.ui.reportPreviewTable)).then(function (data) {
                    for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                        var item = _a[_i];
                        if (!item.showPreviewButton) {
                            if (!item.showDeleteButton)
                                item.style = { 'color': 'orange', 'font-weight': 'bold', 'height': '55px' };
                            else if (item.isSpreadSheet)
                                item.style = { 'color': 'black', 'font-weight': 'normal' };
                            else
                                item.style = { 'color': 'red', 'font-weight': 'bold' };
                        }
                    }
                    _this.paginationInfo = data.paginationInfo;
                    _this.finishedReportList = _this.checkPreviouslyMarkedItemsAgain(data.items);
                    _this.ui.reportPreviewTable.data = _this.finishedReportList;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.loading.list = false;
                    _this.loading.unfetched = _this.showOnlyUnfetchedData;
                    _this.loading.daysInPast = _this.daysInPast;
                    _this.loading.page = _this.page;
                    if (_this.externallySelectedReportId !== undefined) {
                        for (var _b = 0, _c = _this.finishedReportList; _b < _c.length; _b++) {
                            var finishedReport = _c[_b];
                            if (finishedReport.objectId === _this.externallySelectedReportId) {
                                _this.selectedReportObject = finishedReport;
                                _this.getFinishedReportFile(finishedReport);
                            }
                        }
                    }
                    _this.$qui.scopeApply(_this.$scope);
                    $('html,body').animate({
                        scrollTop: $("#docuBox").offset().top - 25
                    }, 500);
                });
            };
            ReportPreviewListController.prototype.refresh = function (value) {
                this.resetFormProperties(value);
                this.getData();
                this.setWidgetRefresh();
            };
            /*acquires the finished report file from the server for preview*/
            ReportPreviewListController.prototype.getFinishedReportFile = function (reportObject) {
                var _this = this;
                console.log("Getting file for ", reportObject.reportName);
                this.base64Data = undefined;
                this.reportingService.getFinishedReportFile(reportObject).then(function (data) {
                    _this.base64Data = data.base64;
                    _this.fileName = data.filename;
                    _this.reportFileId = data.objectId;
                    _this.resetFormProperties(false);
                    _this.getData();
                    _this.setWidgetRefresh();
                    setTimeout(function () {
                        if (reportObject.serverJobType === 6000 || reportObject.serverJobType === 7000) {
                            //pdf files - serverJobType 6000 (form template) & 7000 (normal report))
                            _this.fileType = 'pdf';
                        }
                        else if (reportObject.serverJobType === 3000) {
                            //xls files - serverJobType 3000
                            _this.fileType = 'excel';
                        }
                        $('#loadingScreenModal').modal('hide');
                        _this.$qui.scopeApply(_this.$scope);
                        $('html,body').animate({
                            scrollTop: $("#docuBox").offset().top - 25
                        }, 500);
                    }, 500);
                });
            };
            ReportPreviewListController.prototype.getPdfXlsFile = function (getPdf) {
                var _this = this;
                if (getPdf) {
                    $('#loadingScreenModal').modal('show');
                    this.reportingService.getFinishedSpreadServerJobAsPdf(this.selectedReportObject.objectId, this.selectedReportObject.reportName).then(function (data) {
                        _this.base64Data = data.base64;
                        _this.fileType = 'pdf';
                        setTimeout(function () {
                            _this.$qui.scopeApply(_this.$scope);
                            $('#loadingScreenModal').modal('hide');
                            $('html,body').animate({
                                scrollTop: $("#pdfViewer").offset().top
                            }, 500);
                            //refresh table after animation/scrolling down
                            _this.refresh(false);
                        }, 1000);
                    });
                }
                else {
                    var absoluteUrl = window.location.href;
                    var sessionData = $('#session').data();
                    absoluteUrl = absoluteUrl.replace(window.location.hash, "");
                    var correctedFileName = this.replaceUmlauts(this.selectedReportObject.reportName);
                    var completeUrl = absoluteUrl + 'Reporting/FinishedReportFile?apiPath=' + sessionData.api + '&finishedReportJobObjectId='
                        + this.selectedReportObject.objectId + '&finishedReportType=' + this.selectedReportObject.serverJobType + '&finishedReportName='
                        + correctedFileName + '&spreadAsPdf=' + false + '&bearer=' + this.reportingService.getAccessToken();
                    window.open(completeUrl);
                    setTimeout(function () {
                        _this.refresh(false);
                    }, 1000);
                }
            };
            /* deletes a given finished report database entry and its files*/
            ReportPreviewListController.prototype.deleteFinishedReport = function (reportObject) {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    _this.loading.list = true;
                    _this.finishedReportList = [];
                    if (data) {
                        console.log("finished report '%s' is being deleted right now...", reportObject.reportName);
                        _this.reportingService.deleteSelectedReport(reportObject).then(function (data) {
                            if (data.isDeleteDataBaseEntrySuccessful || data.isDeleteFileSuccessful) {
                                _this.$qui.notify(_this.$qui.deleteNote);
                                _this.refresh(true);
                            }
                        });
                    }
                }, '#promptSingle');
            };
            /* reset all previously set properties */
            ReportPreviewListController.prototype.resetFormProperties = function (refreshall) {
                this.selectedReportObject = null;
                this.selectedForRemovalList = [];
                this.externallySelectedReportId = undefined;
                this.finishedReportList = [];
                this.ui.reportPreviewTable.data = [];
                if (refreshall) {
                    this.base64Data = undefined;
                    this.fileType = undefined;
                }
            };
            ReportPreviewListController.prototype.prepareReportPreview = function (reportObject) {
                $('#loadingScreenModal').modal('show');
                this.selectedReportObject = reportObject;
                this.getFinishedReportFile(reportObject);
            };
            /* replaces any umlauts whether upper or lower case with its corresponing ANSII compatible characters  */
            ReportPreviewListController.prototype.replaceUmlauts = function (fileName) {
                var umlautMap = {
                    '\u00dc': 'UE',
                    '\u00c4': 'AE',
                    '\u00d6': 'OE',
                    '\u00fc': 'ue',
                    '\u00e4': 'ae',
                    '\u00f6': 'oe',
                    '\u00df': 'ss',
                };
                var result = fileName.replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, function (a) {
                    var big = umlautMap[a.slice(0, 1)];
                    return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
                }).replace(new RegExp('[' + Object.keys(umlautMap).join('|') + ']', "g"), function (a) { return umlautMap[a]; });
                return this.removeInvalidChars(result);
            };
            ReportPreviewListController.prototype.removeInvalidChars = function (fileName) {
                var fileNameNoWhiteSpace = fileName.replace(/[\s]/g, "_");
                return fileNameNoWhiteSpace.replace(/[\/\?\#\[\]\@\!\$\&\§\'\(\)\*\+\,\;\:\=]/g, "-"); //vgl: https://stackoverflow.com/questions/2366260/whats-valid-and-whats-not-in-a-uri-query
            };
            /* fired when a check in the table is clicked - adds/removes the report from the selected row to list of items to be disposed of */
            ReportPreviewListController.prototype.selectForRemoval = function (checked, item) {
                if (checked) {
                    this.selectedForRemovalList.push(item);
                }
                else {
                    for (var i = 0; i < this.selectedForRemovalList.length; i++) {
                        if (this.selectedForRemovalList[i] === item) {
                            this.selectedForRemovalList.splice(i, 1);
                        }
                    }
                }
            };
            /* Removes a list of given finished reports */
            ReportPreviewListController.prototype.removeSelectedReports = function () {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptionsMulti, function (data) {
                    $('#deletionAwaitModal').modal('show');
                    _this.loading.list = true;
                    _this.finishedReportList = [];
                    if (data) {
                        _this.reportingService.deleteSelectedReports(_this.selectedForRemovalList).then(function () {
                            $('#deletionAwaitModal').modal('hide');
                            if (_this.selectedForRemovalList.length > 1)
                                _this.$qui.notify(_this.$qui.deleteNotes);
                            else if (_this.selectedForRemovalList.length === 1)
                                _this.$qui.notify(_this.$qui.deleteNote);
                            _this.refresh(true);
                        });
                    }
                    else {
                        $('#deletionAwaitModal').modal('hide');
                    }
                }, '#promptMulti');
            };
            ReportPreviewListController.prototype.checkPreviouslyMarkedItemsAgain = function (items) {
                if (this.selectedForRemovalList.length === undefined || this.selectedForRemovalList.length === 0)
                    return items;
                var modifiedData = items;
                modifiedData.forEach(function (element) {
                    element.isSelected = false;
                });
                for (var i = 0; i < modifiedData.length; i++) {
                    var reportId = modifiedData[i].objectId;
                    for (var j = 0; j < this.selectedForRemovalList.length; j++) {
                        if (this.selectedForRemovalList[j].objectId === reportId) {
                            //because reportPreviewTable.data and finishedReportList are the same list
                            modifiedData[i].isSelected = true;
                        }
                    }
                }
                return modifiedData;
            };
            ReportPreviewListController.prototype.setWidgetRefresh = function () {
                $('#qmUnfetchedReports').attr('qm-refresh', 'true');
            };
            ReportPreviewListController.prototype.showErrorInfoModal = function (reportObject) {
                this.errorInfoModalMessage.serverMessage = reportObject.serverMessage;
                this.errorInfoModalMessage.errorTrace = reportObject.errorTrace;
                $('#errorInfoModal').modal('show');
                this.setFaultyReportFetched(reportObject);
            };
            ReportPreviewListController.prototype.setFaultyReportFetched = function (serverJobObject) {
                var _this = this;
                if (!serverJobObject.isFetched) {
                    this.reportingService.markReportFetched(serverJobObject.objectId).then(function () {
                        for (var i = 0; i < _this.finishedReportList.length; i++) {
                            var element = _this.finishedReportList[i];
                            if (element.objectId === serverJobObject.objectId)
                                element.isFetched = true;
                        }
                        _this.ui.reportPreviewTable.data = _this.finishedReportList;
                        _this.$qui.functionWaiter("ui.createTable", _this);
                        _this.setWidgetRefresh();
                    });
                }
            };
            ReportPreviewListController = __decorate([
                QMC.Controller('QMC.Reporting', 'ReportPreviewListController'),
                QMC.Inject('$qui', 'QmcLanguageService', 'ReportingService', 'UserService', '$location', '$scope', '$state', '$stateParams')
            ], ReportPreviewListController);
            return ReportPreviewListController;
        }());
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Reporting;
    (function (Reporting) {
        /**
         * Report preview user interface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         *
         * */
        var UserInterfaceReportPreview = /** @class */ (function (_super) {
            __extends(UserInterfaceReportPreview, _super);
            function UserInterfaceReportPreview() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                /*
                 * finished Reportlist table
                 * @memberOf UserInterface
                 */
                _this.reportPreviewTable = {
                    "config": {
                        "defaultSort": "date",
                        "sortReverse": "false"
                    },
                    "table": {
                        "Löschen": {
                            "id": "objectId",
                            "selected": "isSelected",
                            "dType": "Checkbox",
                            "lngTag": "20000002",
                            "events": {
                                "onChange": "selectForRemoval"
                            }
                        },
                        "Vorlagentyp": {
                            "label": "reportTypeString",
                            "dType": "string",
                            "lngTag": "20015032"
                        },
                        "Status": {
                            "label": "jobStatus",
                            "dType": "string",
                            "lngTag": "20000164",
                            "style": "style"
                        },
                        "Auswertung": {
                            "label": "reportName",
                            "dType": "string",
                            "lngTag": "20015030"
                        },
                        "Startzeit": {
                            "label": "startTime",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20015029"
                        },
                        "Endzeit": {
                            "label": "finishTime",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20015054"
                        },
                        "Abgeholt": {
                            "label": "isFetched",
                            "dType": "Bool",
                            "lngTag": "20015031"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-eye blue",
                                "click": "prepareReportPreview",
                                "dType": "Button",
                                "tooltip": "Betrachten",
                                "lngTag": "20015033",
                                "events": {
                                    "hide": "!showPreviewButton"
                                },
                            },
                            {
                                "icon": "qm-icon-information orange",
                                "click": "showErrorInfoModal",
                                "dType": "Button",
                                "tooltip": "Fehlerinfo",
                                "lngTag": "20015062",
                                "hideSpacer": "hasBeenCanceled",
                                "events": {
                                    "hide": "!showInfoButton"
                                },
                            },
                            {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFinishedReport",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "events": {
                                    "hide": "!showDeleteButton"
                                },
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-form"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "reportName",
                                "dType": "string"
                            },
                            {
                                "label": "reportTypeString",
                                "dType": "string"
                            },
                            {
                                "label": "isFetched",
                                "dType": "Bool"
                            },
                            {
                                "label": "finishTime",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "prepareReportPreview",
                                "dType": "Button",
                                "tooltip": "Betrachten",
                                "lngTag": "20015033",
                                "events": {
                                    "hide": "!showPreviewButton"
                                }
                            },
                            {
                                "icon": "qm-icon-information orange",
                                "click": "showErrorInfoModal",
                                "dType": "Button",
                                "tooltip": "Fehlerinfo",
                                "lngTag": "20015062",
                                "hideSpacer": "hasBeenCanceled",
                                "events": {
                                    "hide": "!showInfoButton"
                                }
                            },
                            {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFinishedReport",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "events": {
                                    "hide": "!showDeleteButton"
                                }
                            }
                        ]
                    },
                    "data": null
                };
                return _this;
            }
            return UserInterfaceReportPreview;
        }(QMC.Common.UserInterface));
        Reporting.UserInterfaceReportPreview = UserInterfaceReportPreview;
    })(Reporting = QMC.Reporting || (QMC.Reporting = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Reporting/qmc.reporting.js.map
